module.exports = "<ui-select multiple ng-model=\"$ctrl.value\" uis-open-close=\"$ctrl.updateViewValue(isOpen)\" on-remove=\"$ctrl.setValue($item, $model)\">\n    <ui-select-match placeholder=\"Properties\">\n        {{ $item.name }}\n    </ui-select-match>\n    <ui-select-choices repeat=\"property in $ctrl.properties | filter: $select.search track by property.id\">\n        <span ng-bind=\"property.name\"></span>\n    </ui-select-choices>\n</ui-select>\n";


//////////////////
// WEBPACK FOOTER
// ./frontend/admin/app/modules/property/views/properties.select.html
// module id = 541
// module chunks = 0